<template>
  <div class="playground-frame">
    <iframe id="iframe" style="width: 100%;"></iframe>
  </div>
</template>

<script>
    import {TASK_PLAYGROUND_REQUEST} from "../../store/actions/task";

    export default {
        name: "PreviewFrame",
        props: ['taskId', 'type'],
        data() {
            return {
                taskPlayground: null
            }
        },
        created() {
            this.$store.dispatch(TASK_PLAYGROUND_REQUEST, this.taskId).then((taskPlayground) => {
                this.taskPlayground = taskPlayground;
                this.initTaskFrame(taskPlayground);
            });
        },
        methods: {
            initTaskFrame(taskPlayground) {
                let codeSources = [];
                let baseCss = `.workflow-content{display: flex;justify-content: center;text-align: center;}`;

                switch (this.type) {
                    case "result":
                        codeSources = taskPlayground.results;
                        break;
                    case "source":
                        codeSources = taskPlayground.sources;
                        break;
                }

                let iframe = document.getElementById('iframe');
                let sources = iframe.contentWindow.document;
                let code = `<style>${baseCss}</style>`;

                codeSources.forEach(codeSource => {
                  switch (codeSource.mode) {
                      case "html":
                          code += `<div class="workflow-content">${codeSource.code}</div>`;
                          break;
                      case "css":
                          code += `<style>${codeSource.code}</style>`;
                          break;
                  }
                });

                sources.open();
                sources.write(code);
                sources.close();

                this.resizeFrame(iframe);
            },
            resizeFrame(iframe) {
                let content = iframe.contentDocument || iframe.contentWindow.document;

                setTimeout(() => {
                    iframe.height = content.body.querySelector('.workflow-content')
                        .scrollHeight + 10;
                    content.body.style.overflow = 'hidden';
                }, 4000)
            }
        }
    }
</script>

<style lang="scss">
  .playground-frame {
    margin-top: 55px;

    iframe {
      border: 0;
    }
  }
</style>
